import { ADD_NOW_PLAYING_MOVIES } from "../action/action-types";

export default function moviesNow(state = { data: [] }, action){
    switch(action.type){
        case ADD_NOW_PLAYING_MOVIES:
            return { ...state, data: action.payload }
        default:
            return state
    }
}